import React from 'react'

function Arrow({className}) {
    return (     
        <svg className={className} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path d="M18.1198 21.75C17.5198 21.75 16.9098 21.61 16.3298 21.32L13.0898 19.7C12.4098 19.36 11.5898 19.36 10.8998 19.7L7.65985 21.32C6.09985 22.1 4.29985 21.8 3.07985 20.55C1.85985 19.3 1.58985 17.5 2.40985 15.95L8.50985 4.36C9.18985 3.06 10.5298 2.25 11.9998 2.25C13.4698 2.25 14.8098 3.06 15.4898 4.36L21.5898 15.95C22.3998 17.5 22.1398 19.3 20.9198 20.55C20.1498 21.34 19.1498 21.75 18.1198 21.75ZM11.9998 17.94C12.6098 17.94 13.2098 18.08 13.7598 18.35L16.9998 19.97C18.1698 20.56 19.2398 20.11 19.8398 19.49C20.4398 18.87 20.8698 17.8 20.2598 16.64L14.1598 5.05C13.7298 4.24 12.9198 3.75 11.9998 3.75C11.0798 3.75 10.2698 4.24 9.83985 5.06L3.73985 16.65C3.12985 17.81 3.54985 18.89 4.15985 19.5C4.76985 20.11 5.82985 20.56 6.99985 19.98L10.2398 18.36C10.7898 18.08 11.3898 17.94 11.9998 17.94Z"/>
        </svg>
    )
}

export default Arrow
